import {
	CREATE_REVIEW_REQUEST,
	CREATE_REVIEW_REQUEST_FAILED,
	CREATE_REVIEW_REQUEST_RESET,
	CREATE_REVIEW_REQUEST_SUCCESS,
	GET_REVIEW_LIST_REQUEST,
	GET_REVIEW_LIST_REQUEST_FAILED,
	GET_REVIEW_LIST_REQUEST_RESET,
	GET_REVIEW_LIST_REQUEST_SUCCESS,
	GET_REVIEW_REQUEST,
	GET_REVIEW_REQUEST_FAILED,
	GET_REVIEW_REQUEST_RESET,
	GET_REVIEW_REQUEST_SUCCESS,
	IS_CASE_ADMIN,
	IS_UPDATE_TRIGGER,
	RESET_REVIEW,
	RESET_REVIEW_FORM,
	SET_REVIEW,
	SET_REVIEW_ASSIGNEE,
	SET_REVIEW_ASSIGNEE_MAP,
	SET_REVIEW_CURRENT_ASSIGNEE,
	SET_REVIEW_FORM_OPEN,
	SET_REVIEW_JOBID,
	SET_REVIEW_RESTRICT_IDS,
	UPDATE_REVIEW_METADATA,
	UPDATE_REVIEW_STATUS_FAILED,
	UPDATE_REVIEW_STATUS_SUCCESS,
	GET_REVIEW_BASED_ON_ID,
	GET_REVIEW_BASED_ON_ID_SUCCESS,
	GET_REVIEW_BASED_ON_ID_FAILED,
	GET_REVIEW_BASED_ON_ID_RESET,
	GET_ALL_REVIEWS_LIST_REQUEST,
	GET_ALL_REVIEWS_LIST_REQUEST_SUCCESS,
	GET_ALL_REVIEWS_LIST_REQUEST_FAILED,
	GET_ALL_REVIEWS_LIST_REQUEST_RESET,
} from "../types"
import _ from "lodash"

const initialState = {
	review: {},
	reviewBasedOnFileId: [],
	restrictIds: [],
	isLoading: false,
	reviewJobId: "",
	reviewAssignee: {},
	reviewCurrentAsignee: "",
	assigneeMap: new Map(),
	isSaving: false,
	isSaved: false,
	create: {},
	list: [],
	listLoading: false,
	isReviewFormOpen: false,
	isUpdateTrigger: false,
	is_case_admin: false,
	allReviewlist: [],
	allReviewlistLoading: false,
}

export default function (state = initialState, action) {
	switch (action.type) {
		case SET_REVIEW:
			return {
				...state,
				review: action.payload,
			}
		case RESET_REVIEW:
			return {
				...initialState,
				list: _.cloneDeep(state.list),
			}
		case SET_REVIEW_RESTRICT_IDS:
			return {
				...state,
				restrictIds: action.payload || [],
			}
		case SET_REVIEW_JOBID:
			return {
				...state,
				reviewJobId: action.payload,
			}
		case SET_REVIEW_ASSIGNEE:
			return {
				...state,
				reviewAssignee: action.payload,
			}
		case SET_REVIEW_CURRENT_ASSIGNEE:
			return {
				...state,
				reviewCurrentAsignee: action.payload,
			}
		case SET_REVIEW_ASSIGNEE_MAP:
			return {
				...state,
				assigneeMap: action.payload,
			}
		case RESET_REVIEW_FORM:
			if (action?.payload?.is_case_admin) {
				return {
					...state,
					reviewJobId: "",
					reviewCurrentAsignee: "",
				}
			} else {
				return {
					...state,
					reviewJobId: "",
					reviewCurrentAsignee: "",
					reviewAssignee: {},
					assigneeMap: new Map(),
				}
			}
		case CREATE_REVIEW_REQUEST:
			return {
				...state,
				create: action.payload,
				isSaving: true,
				isSaved: false,
			}
		case CREATE_REVIEW_REQUEST_SUCCESS:
			return {
				...state,
				create: action.payload,
				isSaving: false,
				isSaved: true,
			}
		case CREATE_REVIEW_REQUEST_FAILED:
			return {
				...state,
				error: action.payload,
				isSaving: false,
				isSaved: false,
			}
		case CREATE_REVIEW_REQUEST_RESET:
			return {
				...state,
				error: undefined,
				isSaving: false,
				isSaved: false,
				create: {},
			}

		case GET_REVIEW_LIST_REQUEST:
			return {
				...state,
				listLoading: true,
				//list: []
			}
		case GET_REVIEW_LIST_REQUEST_SUCCESS:
			return {
				...state,
				list: action.payload,
				listLoading: false,
			}
		case GET_REVIEW_LIST_REQUEST_FAILED:
			return {
				...state,
				error: action.payload,
				listLoading: false,
			}
		case GET_REVIEW_LIST_REQUEST_RESET:
			return {
				...state,
				error: undefined,
				listLoading: false,
			}
		case GET_ALL_REVIEWS_LIST_REQUEST:
			return {
				...state,
				listLoading: true,
			}
		case GET_ALL_REVIEWS_LIST_REQUEST_SUCCESS:
			return {
				...state,
				allReviewlist: action.payload,
				allReviewlistLoading: false,
			}
		case GET_ALL_REVIEWS_LIST_REQUEST_FAILED:
			return {
				...state,
				error: action.payload,
				allReviewlistLoading: false,
			}
		case GET_ALL_REVIEWS_LIST_REQUEST_RESET:
			return {
				...state,
				error: undefined,
				allReviewlistLoading: false,
			}

		case GET_REVIEW_REQUEST:
			return {
				...state,
				isLoading: true,
				reviewAssignee: {},
				assigneeMap: new Map(),
				is_case_admin: action?.payload?.is_case_admin,
			}
		case GET_REVIEW_REQUEST_SUCCESS:
			let reviewClone = _.cloneDeep(state.review)
			reviewClone = { ...reviewClone, ...action.payload }
			return {
				...state,
				review: reviewClone,
				isLoading: false,
			}
		case GET_REVIEW_REQUEST_FAILED:
			return {
				...state,
				error: action.payload,
				isLoading: false,
			}
		case GET_REVIEW_REQUEST_RESET:
			return {
				...state,
				error: undefined,
				isLoading: false,
			}
		case SET_REVIEW_FORM_OPEN:
			return {
				...state,
				isReviewFormOpen: action.payload,
			}
		case UPDATE_REVIEW_STATUS_SUCCESS: {
			return {
				...state,
				review: action.payload,
			}
		}
		case UPDATE_REVIEW_STATUS_FAILED: {
			return {
				...state,
			}
		}
		case UPDATE_REVIEW_METADATA: {
			return {
				...state,
				review: action?.payload?.review,
				isUpdateTrigger: action?.payload?.isUpdateTrigger,
			}
		}
		case IS_UPDATE_TRIGGER: {
			return {
				...state,
				isUpdateTrigger: action?.payload,
			}
		}
		case IS_CASE_ADMIN: {
			return {
				...state,
				is_case_admin: action?.payload,
			}
		}

		case GET_REVIEW_BASED_ON_ID: {
			return {
				...state,
			}
		}
		case GET_REVIEW_BASED_ON_ID_SUCCESS: {
			return {
				...state,
				reviewBasedOnFileId: action.payload,
			}
		}
		case GET_REVIEW_BASED_ON_ID_FAILED: {
			return {
				...state,
				reviewBasedOnFileId: [],
			}
		}
		case GET_REVIEW_BASED_ON_ID_RESET: {
			return {
				...state,
				reviewBasedOnFileId: [],
			}
		}
		default:
			return state
	}
}
